import { CheckCircle2, AlertTriangle, XCircle, RefreshCw } from 'lucide-react';

interface SystemHealthBannerProps {
  status: 'operational' | 'warning' | 'error';
  message: string;
  details?: string;
  onRefresh?: () => void;
}

export function SystemHealthBanner({
  status,
  message,
  details,
  onRefresh,
}: SystemHealthBannerProps) {
  const statusConfig = {
    operational: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      icon: 'text-green-600',
      text: 'text-green-900',
      subtext: 'text-green-700',
      Icon: CheckCircle2,
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-200',
      icon: 'text-yellow-600',
      text: 'text-yellow-900',
      subtext: 'text-yellow-700',
      Icon: AlertTriangle,
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      icon: 'text-red-600',
      text: 'text-red-900',
      subtext: 'text-red-700',
      Icon: XCircle,
    },
  };

  const config = statusConfig[status];

  return (
    <div className={`${config.bg} ${config.border} border rounded-xl p-4 flex items-start gap-3`}>
      <config.Icon className={`w-5 h-5 ${config.icon} mt-0.5 flex-shrink-0`} />
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-medium ${config.text}`}>{message}</p>
        {details && (
          <p className={`text-sm ${config.subtext} mt-0.5`}>{details}</p>
        )}
      </div>
      {onRefresh && (
        <button
          onClick={onRefresh}
          className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-1.5 flex-shrink-0"
        >
          <RefreshCw className="w-3.5 h-3.5" />
          Refresh
        </button>
      )}
    </div>
  );
}
